import { render } from "./UsageManualPage.vue?vue&type=template&id=4473aaf4&scoped=true"
import script from "./UsageManualPage.vue?vue&type=script&lang=js"
export * from "./UsageManualPage.vue?vue&type=script&lang=js"

import "./UsageManualPage.vue?vue&type=style&index=0&id=4473aaf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4473aaf4"]])

export default __exports__